import type { UseFormRegister, Path, FieldValues } from 'react-hook-form';

export type FormSelectOption = {
    value: string;
    label: string;
};

type FormSelectProps<T extends FieldValues> = {
    name: Path<T>;
    label: string;
    register: UseFormRegister<T>;
    registerOptions?: Parameters<UseFormRegister<T>>[1];
    options: FormSelectOption[];
    placeholder?: string;
    required?: boolean;
    disabled?: boolean;
};

export default function FormSelect<T extends FieldValues>({
    name,
    label,
    register,
    registerOptions,
    options,
    placeholder,
    required = false,
    disabled = false
}: FormSelectProps<T>) {
    return (
        <div className="space-y-3">
            <label className="block text-body-14 font-semibold text-[var(--on-surface-color)]">
                {label} {required && '*'}
            </label>
            <select
                {...register(name, registerOptions)}
                disabled={disabled}
                className="w-full p-3 border rounded-8 transition-colors focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[var(--focus-ring-color)] disabled:opacity-50 border-[rgba(var(--on-surface-color),0.3)] bg-transparent text-[var(--on-surface-color)]">
                {placeholder && <option value="">{placeholder}</option>}
                {options.map((option) => (
                    <option
                        key={option.value}
                        value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
}
